<template>
    <nav id="nav">
        <ah-nav2 :brand-img="companyLogo" :active="activeMenu" :menuData="menuData" :isAllShown="isAllShown" @reset="updateReCalculateDialogVisible(true)" />
    </nav>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import ahNav2 from '@/components/ui/ahNav2.vue';
import { menu } from '@/assets/commonData/menu';

export default {
    components: { ahNav2 },
    props: {
        msg: String,
    },
    data() {
        return {
            menu,
        };
    },
    methods: {
        ...mapMutations({
            updateReCalculateDialogVisible: 'globalDialogState/updateReCalculateDialogVisible',
        }),
    },
    computed: {
        ...mapGetters({ userGrP_NO: 'account/userGrP_NO' }),
        isSwitchShow() {
            return this.userGrP_NO === 'OT1' || this.userGrP_NO === 'OT2' || this.userGrP_NO === 'OT3' || this.userGrP_NO === 'OT4';
        },
        activeMenu() {
            const route = this.$route;
            const { meta, name } = route;

            // PF 選單只有一層
            if (this.$store.getters['account/isPFAgent']) {
                return name;
            }

            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return name;
        },
        companyLogo() {
            return this.$store.getters['menu/companyInfo'].logo;
        },
        companyName() {
            return this.$store.getters['menu/companyInfo'].cH_CMP;
        },
        companyColor() {
            return this.$store.getters['menu/companyInfo'].color;
        },
        accountAdminMenu() {
            return [
                {
                    title: '帳號權限管理',
                    index: 'staff',
                    activeMenu: 'staff',
                },
                {
                    title: '部門管理',
                    index: 'department',
                    activeMenu: 'department',
                },
            ];
        },
        menuData() {
            // all menus
            const normalMenus = menu;

            // 帳號管理員權限
            const adminMenus = [
                {
                    title: '帳號',
                    index: 'admin',
                    activeMenu: 'admin',
                    auths: ['admin', 'ahoo-agent'],
                    groups: [
                        {
                            title: '帳號管理',
                            key: 'user-management',
                            auths: ['admin', 'ahoo-agent'],
                            children: [
                                {
                                    title: '帳號管理',
                                    index: 'staff',
                                    auths: ['admin', 'ahoo-agent'],
                                },
                                {
                                    title: '部門設定',
                                    index: 'department',
                                    auths: ['admin', 'ahoo-agent'],
                                },
                                {
                                    title: '身份功能設定',
                                    index: 'staff-roles',
                                    auths: ['admin', 'ahoo-agent'],
                                },
                            ],
                        },
                    ],
                },
            ];

            const pfMenus = [
                {
                    title: '首頁',
                    index: 'index',
                    activeMenu: 'index',
                    auths: [],
                },
                {
                    title: '收支項目設定',
                    index: 'trade-statement',
                    activeMenu: 'trade-statement',
                    auths: ['F05'],
                },
                {
                    title: '會計科目設定',
                    index: 'accounting-setting',
                    activeMenu: 'accounting-setting',
                    auths: [],
                },
                {
                    title: '會計科目對照表',
                    index: 'accounting-relation-setting',
                    activeMenu: 'accounting-relation-setting',
                    auths: [],
                },
            ];

            // 財務專員
            if (this.$store.getters['account/isSAAdmin']) {
                return normalMenus.concat(adminMenus);
            }
            // 帳號管理員
            if (this.$store.getters['account/isAccAdmin']) {
                return adminMenus;
            }
            //  PF 財務顧問
            if (this.$store.getters['account/isPFAgent']) {
                return pfMenus;
            }
            if (this.isSwitchShow) {
                const INDEX_PAGE_INDEX = normalMenus.findIndex((o) => o.activeMenu === 'index');
                if (INDEX_PAGE_INDEX >= 0) normalMenus.splice(normalMenus, 1);

                return normalMenus;
            }
            // 一般帳號
            return normalMenus;
        },
        isAllShown() {
            return this.$store.getters['account/isAhooAgent'] || this.$store.getters['account/isSAAdmin'];
        },
    },

    created() {
        this.$store.dispatch('menu/updateMenu');
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

#nav {
    @media print {
        display: none;
    }
}
</style>
